export default "__VITE_ASSET__UiGLKL2L__"